import React from 'react';
import {
  Grid,
} from '@material-ui/core'
import {
  AssignmentTurnedIn as AssignmentTurnedInIcon,
  FiberNew as FiberNewIcon,
  ShowChart as ShowChartIcon,
  TrendingFlat as TrendingFlatIcon,
} from '@material-ui/icons';
import Tabs from 'components/CustomTabs/CustomTabs';

import ReactResizeDetector from 'react-resize-detector';

import CoupangPartners from '../../components/CoupangPartners/CoupangPartners';

import StockConsensus from './StockConsensus';
import StockConsensusNew from './StockConsensusNew';
import StockPeriod from './StockPeriod';
import StockSideway from './StockSideway';

export default class Stock extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      tabs: [
        {
          tabName: "Consensus",
          tabIcon: AssignmentTurnedInIcon,
          path: "/stock/consensus",
          tabContent: (
            <StockConsensus />
          )
        },
        {
          tabName: "Consensus New",
          tabIcon: FiberNewIcon,
          path: "/stock/consensus_new",
          tabContent: (
            <StockConsensusNew />
          )
        },
        {
          tabName: "기간수익",
          tabIcon: ShowChartIcon,
          path: "/stock/period",
          tabContent: (
            <StockPeriod />
          )
        },
        {
          tabName: "횡보",
          tabIcon: TrendingFlatIcon,
          path: "/stock/sideway",
          tabContent: (
            <StockSideway />
          )
        }
      ]
    }
  }

  getTabsValue = () => {
    let idx = this.state.tabs.map((e) => e.path).indexOf(window.location.pathname);
    return idx === -1 ? 0:idx;
  }

  render() {
    return (
      <Grid container>
        <Grid item xs={12}>
          <ReactResizeDetector handleWidth handleHeight>
            {({ width, height }) => <CoupangPartners width={width} height={height} />}
          </ReactResizeDetector>
        </Grid>
        <Grid item xs={12}>
          <Tabs
            title=""
            headerColor="success"
            value={this.getTabsValue}
            tabs={this.state.tabs}
          />
        </Grid>
      </Grid>
    );
  }
}